"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Account = void 0;
const rtbxDaily_1 = require("./rtbxDaily");
const rtbxHourly_1 = require("./rtbxHourly");
const app_module_1 = require("./app.module");
const token_service_1 = require("./token.service");
const _ = require("lodash");
const loading_service_1 = require("./loading.service");
const notification_service_1 = require("./notification.service");
const moment = require('moment');
const baseURL = '/helm';
class Account {
    constructor(params = {}) {
        this.bidderName = '';
        this.bidderBillingSource = false;
        this.interval = 'daily';
        this.hourlyInterval = false;
        this.dailyChangeMade = false;
        let formatted = Object.assign(Object.assign({ id: Account.dspAsAccount ? Number(params.bidder) : Number(params.client_id), displayName: Account.dspAsAccount ? params.bidderName : params.client_name, startTime: params.startTime, endTime: params.endTime, bidder: params.bidder }, (params.hourly ? { hourly: params.hourly } : null)), { daily: params.daily, bidderName: params.bidderName, bidderBillingSource: params.bidderBillingSource });
        Object.assign(this, formatted);
    }
    ;
    static _initTalk() {
        this._talk = app_module_1.AppModule.injector.get(notification_service_1.NotificationService);
    }
    static talk(msg) {
        if (!this._talk || (this._talk && !this._talk.broadcast)) {
            this._initTalk();
        }
        this._talk.broadcast(msg);
    }
    static deserialize(data = {}, params = {}, isHourly = false) {
        data.startTime = params.startTime;
        data.endTime = params.endTime;
        data.bidder = params.bidder;
        data.bidderName = params.bidderName;
        data.bidderBillingSource = params.bidderBillingSource;
        if (isHourly) {
            return rtbxHourly_1.RtbxHourly.deserialize(data);
        }
        else {
            data.daily = rtbxDaily_1.RtbxDaily.deserialize(data);
        }
        let account = new Account(data);
        return account;
    }
    static assemble(accounts) {
        return _.reduce(accounts, (result, value, key) => {
            let change = Account.dspAsAccount ? {} : {
                id: value.getId(),
                displayName: value.getDisplayName()
            };
            let daily = value.dailyChange();
            let hourly = value.hourlyChanges();
            if (!_.isEmpty(daily) && !_.isEmpty(hourly)) {
                change.daily = daily;
                change.hourly = hourly;
                result.push(change);
            }
            else if (!_.isEmpty(daily)) {
                change.daily = daily;
                result.push(change);
            }
            return result;
        }, []);
    }
    find() {
        return __awaiter(this, arguments, void 0, function* (params = {}) {
            Object.assign(this, params);
            let _http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
            params.dspAsAccount = Account.dspAsAccount;
            return new Promise((resolve, reject) => {
                _http.post(baseURL, JSON.stringify(params))
                    .toPromise()
                    .then(response => response.json())
                    .then(response => {
                    if (this.interval === 'daily') {
                        let accounts = response.rows.map(account => {
                            account = Account.deserialize(account, this);
                            account.daily.calculateRow();
                            return account;
                        });
                        resolve(accounts);
                    }
                    else {
                        let hours = response.rows.map(hour => {
                            hour = Account.deserialize(hour, this, true);
                            hour.calculateRow();
                            return hour;
                        });
                        resolve(hours);
                    }
                })
                    .catch(err => {
                    let res = err.json ? err.json() : err;
                    reject(res);
                });
            });
        });
    }
    static update(params) {
        let http = app_module_1.AppModule.injector.get(token_service_1.TokenService);
        params.dspAsAccount = this.dspAsAccount;
        params.date = params.date.toString();
        return new Promise((resolve, reject) => {
            http.put(`${baseURL}`, params)
                .toPromise()
                .then(response => {
                resolve('Success!');
            })
                .catch(err => {
                reject(err);
            });
        });
    }
    /**
     *
     * @param isHourlyChange - boolean: if the row that was modified was hourly or not
     */
    cascadeChanges(header, hourTime) {
        if (!hourTime) {
            this.dailyChangeMade = true;
        }
        // if the header contains disc then it's referring to a discrepancy, or percentage change;
        // let isPercentageChange = !!header.toLowerCase().indexOf('disc');
        // - hourly doesnt exist yet, so this change is not on hourly
        if (!this.hourly) {
            // Flow A - Focus: Daily
            this.daily[`get${_.capitalize(header)}Changed`]();
            this.daily.calculateCpmMetrics();
        }
        else {
            let rawMetricColumn = this.hourly[0].getRawMetricToCalculate(header);
            if (hourTime) {
                // Flow C - Focus: Hourly to Daily
                // this adjusts the given hour
                let adjustedHour = this.hourly.filter(hour => {
                    return hour.hour === hourTime;
                })[0];
                adjustedHour[`get${_.capitalize(header)}Changed`]();
                adjustedHour.calculateCpmMetrics();
                this.daily[rawMetricColumn] = rtbxHourly_1.RtbxHourly.sumColumn(rawMetricColumn, this.hourly, header);
                this.daily[`get${_.capitalize(rawMetricColumn)}Changed`]();
                this.daily.calculateCpmMetrics();
            }
            else {
                // Flow B - Focus: Daily To Hourly
                this.daily[`get${_.capitalize(header)}Changed`]();
                this.daily.calculateCpmMetrics();
                this.hourly.forEach(hour => {
                    // need to get this down here to wait for daily to update itself;
                    let dailyMetricValue = this.daily[rawMetricColumn];
                    hour[`downfill${_.capitalize(rawMetricColumn)}`](dailyMetricValue);
                    hour[`get${_.capitalize(rawMetricColumn)}Changed`]();
                    hour.calculateCpmMetrics();
                });
            }
        }
    }
    getTooltip() {
        return !this.hourlyInterval ? 'Click to Expand to Hourly View' : 'Click to Collapse to Daily View';
    }
    getId() {
        return Account.dspAsAccount ? null : this.id;
    }
    getDisplayName() {
        return this.displayName;
    }
    dailyChange() {
        return this.daily.diff();
    }
    hourlyChanges() {
        return _.reduce(this.hourly, (result, hour, key) => {
            let change = hour.diff();
            if (!_.isEmpty(change)) {
                result.push(change);
            }
            return result;
        }, []);
    }
    toggleInterval() {
        return __awaiter(this, void 0, void 0, function* () {
            this.hourlyInterval = !this.hourlyInterval;
            if (this.hourlyInterval && !this.hourly) {
                let loading = app_module_1.AppModule.injector.get(loading_service_1.LoadingService);
                loading.start();
                this.hourly = (yield this.find({
                    startTime: this.startTime,
                    endTime: this.endTime,
                    interval: 'hourly',
                    bidder: this.bidder,
                    bidderName: this.bidderName,
                    bidderBillingSource: this.bidderBillingSource,
                    clients: [this.id]
                }));
                // if weve ever made a daily change on this account, this will evaluate
                if (this.dailyChangeMade) {
                    // when hourly is called, we have to cascade any daily changes down
                    // but we dont want an hourly cascade if daily change has not occurred
                    this.cascadeChanges('impsAdj');
                    this.cascadeChanges('revAdj');
                }
                loading.stop();
            }
        });
    }
    validate(val) {
        let allValid = true;
        if (val.impsAdj && typeof val.impsAdj !== 'number') {
            allValid = false;
        }
        if (val.revAdj && typeof val.revAdj !== 'number') {
            allValid = false;
        }
        return allValid;
    }
}
exports.Account = Account;
Account.dspAsAccount = true;
//# sourceMappingURL=account.js.map